import { z4 } from '@fiverr-private/forms';
import { translate } from '../translate';

export const FIVERR_DOMAIN = '@fiverr.com';
export const FIVERR_ALLOWED_SUFFIX = '+5rr';

export const emailValidator = () =>
    z4
        .email({ error: translate('validation.email.incomplete') })
        .refine(
            (email) => email.endsWith(FIVERR_DOMAIN) || email.includes(FIVERR_ALLOWED_SUFFIX) || !email.includes('+'),
            {
                error: translate('validation.email.format'),
            }
        );
